import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { TeamDomain } from '@/types';
import { useActiveSeason } from '@/hooks/useActiveSeason';
import { teamKeys } from './keys';
import { mapBackendTeams } from './teamMapper';

const LIST_STALE_TIME = 5 * 60_000;

/** Shared with the launch prefetch of the offline read cache. */
export const teamListQuery = (season: string) => ({
  queryKey: [...teamKeys.all, season],
  queryFn: async (): Promise<TeamDomain[]> => mapBackendTeams(await api.getTeams(season)),
  staleTime: LIST_STALE_TIME,
});

export function useTeams() {
  const season = useActiveSeason();
  return useQuery<TeamDomain[]>(teamListQuery(season));
}
